import { dataLayerService } from './dataLayerService';
import { getAnalyticsUserId } from './getAnalyticsUserId';

export const optimizelyPlugin = (optimizelyInstance?: any) => ({
  name: 'optimizely-plugin',

  initialize: ({ config }) => {},

  track: ({ payload }) => {
    if (payload.properties?.suppressBridgeTracking) return;

    const dataLayer = dataLayerService.getDataLayer();
    const eventProps = { ...dataLayer, ...payload.properties };

    // Filter out undefined values from eventProps
    const filteredEventProps = Object.fromEntries(Object.entries(eventProps).filter(([_, v]) => v !== undefined));

    if (optimizelyInstance && payload.event) {
      const userId = getAnalyticsUserId();
      // JS SDK signature: track(eventKey, userId, attributes?, eventTags?)
      // Passing userId is critical for conversion attribution to the same bucketing id.
      optimizelyInstance.track(payload.event, userId, undefined, { $opt_event_properties: filteredEventProps });
    }
  },

  identify: ({ payload }) => {
    if (payload.traits) {
      dataLayerService.updateDataLayer(payload.traits);
    }
  },
});

export default optimizelyPlugin;
